import styled from "styled-components";
import theme from "../../theme/theme";

const Header = styled.h2`
  font-size: 30px;
  font-weight: 700;
  color: ${theme.colors.primaryStrong2X};
`;

const CardHeader = ({ text }) => {
  return (
    <>
      <Header>{text}</Header>
    </>
  );
};

export default CardHeader;
